import React from 'react';
import { observer } from 'mobx-react';

import { InjectedStyledComponent, SvgElement } from '../../../shared/index.js';
import Container from '../Container/Container.js';

import { ISvgCircleConfiguration, ISvgCircleProps, ISvgCircleState } from './models/index.js';
import Wrapper from './styledComponents/Wrapper.js';
import { SVG_CIRCLE_CATEGORY_KEY, SVG_CIRCLE_COMPONENT_KEY } from './SvgCircle.meta.js';

export class SvgCircle extends SvgElement<ISvgCircleProps, ISvgCircleState, ISvgCircleConfiguration> {
	categoryKey = SVG_CIRCLE_CATEGORY_KEY;
	componentKey = SVG_CIRCLE_COMPONENT_KEY;

	render() {
		const { className, cx, cy, ...otherSvgProps } = this.props;
		const radius = this.getNumber(otherSvgProps.r);
		const strokeWidth = this.getNumber(otherSvgProps.strokeWidth || 0);
		const diameter = (radius + strokeWidth / 2) * 2;
		const elementProps = this.getElementSvgProps<SVGCircleElement>({
			cx: cx === undefined ? radius + strokeWidth / 2 : cx,
			cy: cy === undefined ? radius + strokeWidth / 2 : cy,
		});
		const baseProps = this.getBaseSvgProps({
			width: diameter,
			height: diameter,
		});
		return (
			<Wrapper className={className}>
				<Container {...baseProps}>
					<circle {...elementProps} />
				</Container>
			</Wrapper>
		);
	}
}

export default InjectedStyledComponent(observer(SvgCircle), SVG_CIRCLE_CATEGORY_KEY, SVG_CIRCLE_COMPONENT_KEY);
